import { render, staticRenderFns } from "./ManualReleaseDialog.vue?vue&type=template&id=33be5789&scoped=true"
import script from "./ManualReleaseDialog.vue?vue&type=script&lang=js"
export * from "./ManualReleaseDialog.vue?vue&type=script&lang=js"
import style0 from "./ManualReleaseDialog.vue?vue&type=style&index=0&id=33be5789&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33be5789",
  null
  
)

export default component.exports